// extracted by mini-css-extract-plugin
export default {"root":"ProfileSettingsPage_root__C9Eks","userData":"ProfileSettingsPage_userData__XdbOq","avatar":"ProfileSettingsPage_avatar__PlO9D"};